<template>
    <div class="layout">


      <div class="header">
        <div class="header_container">
          <div class="header_logo" @click="route_home()"></div>
          <div class="header_menu">
            <div @click="route_home()">
              <div :class="{'header_menusitems_i1':black,'header_menusitems_i':!black}" @mouseover="turnblack()" @mouseleave="turnblack()">首页</div>
              <div :class="{'blue_line_hidden':!black,'blue_line_show1':black}"></div>
            </div>
            <div  @mouseenter="show()" @mouseleave="show()">
              <div :class="{'header_menusitems1':black2,'header_menusitems':!black2}">产品方案</div>
              <div :class="{'blue_line_show':black2,'blue_line_hidden':!black2}"></div>
              <div :class="{'dropdown_menu_hidden':isshow,'dropdown_menu_show':!isshow}">
                <div :class="{'dropdown_menu_headline':blue1,'dropdown_menu_headline_blue':!blue1}" @mouseover="turnblue1()" @mouseleave="turnblue1()" @click="headline2_show()">设备健康</div>
                <!-- <div :class="{'headline2_content_hidden':headline2,'headline2_content_show':!headline2}">
                  <div :class="{'dropdown_menu_subtitle2':blue2,'dropdown_menu_subtitle2_blue':!blue2}" @mouseover="turnblue2()" @mouseleave="turnblue2()" @click="route_industrial()">工业设备健康与安全监护系统</div>
                </div> -->
                <div :class="{'dropdown_menu_headline':blue3,'dropdown_menu_headline_blue':!blue3}" @mouseover="turnblue3()" @mouseleave="turnblue3()" @click="headline1_show()">智能语音</div>
                <!-- <div :class="{'headline1_content_hidden':headline1,'headline1_content_show':!headline1}">
                  <div :class="{'dropdown_menu_subtitle1':blue4,'dropdown_menu_subtitle1_blue':!blue4}" @mouseover="turnblue4()" @mouseleave="turnblue4()" @click="router_voice_page1()">超大规模高性能声纹库系统</div>
                  <div :class="{'dropdown_menu_subtitle1':blue5,'dropdown_menu_subtitle1_blue':!blue5}" @mouseover="turnblue5()" @mouseleave="turnblue5()" @click="router_voice_page2()">高性能云平台</div>
                  <div :class="{'dropdown_menu_subtitle1':blue6,'dropdown_menu_subtitle1_blue':!blue6}" @mouseover="turnblue6()" @mouseleave="turnblue6()" @click="router_voice_page3()">人机耦合平台</div>
                  <div :class="{'dropdown_menu_subtitle1':blue7,'dropdown_menu_subtitle1_blue':!blue7}" @mouseover="turnblue7()" @mouseleave="turnblue7()" @click="router_voice_page4()">智能语音处理系统</div>
                </div> -->
              </div>
            </div>
            <div @click="route_case()">
              <div :class="{'header_menusitems1':black3,'header_menusitems':!black3}" @mouseover="turnblack3()" @mouseleave="turnblack3()">典型案例</div>
              <div :class="{'blue_line_hidden':!black3,'blue_line_show':black3}"></div>
            </div>
            <div @mouseenter="show5()" @mouseleave="show5()">
                <div :class="{'header_menusitems1':black4,'header_menusitems':!black4}"  @mouseover="turnblack4()" @mouseleave="turnblack4()">关于智加</div>
                <div :class="{'blue_line_hidden':!black4,'blue_line_show':black4}"></div>
                <div :class="{'dropdown_menu_hidden':isshow5,'dropdown_menu_show5':!isshow5}">
                  <div :class="{'dropdown_menu_headline_blue':blue9,'dropdown_menu_headline':!blue9}" @mouseover="turnblue9()" @mouseleave="turnblue9()"  @click="route_introduction()">公司简介</div>
                  <div :class="{'dropdown_menu_headline_blue':blue10,'dropdown_menu_headline':!blue10}" @mouseover="turnblue10()" @mouseleave="turnblue10()"  @click="route_team()">团队介绍</div>
                  <div :class="{'dropdown_menu_headline_blue':blue11,'dropdown_menu_headline':!blue11}" @mouseover="turnblue11()" @mouseleave="turnblue11()"  @click="route_news()">新闻报道</div>
                  <div :class="{'dropdown_menu_headline_blue':blue12,'dropdown_menu_headline':!blue12}" @mouseover="turnblue12()" @mouseleave="turnblue12()"  @click="route_honor()">荣誉资质</div>
                  <!-- <div :class="{'dropdown_menu_headline':blue8,'dropdown_menu_headline_blue':!blue8}" @mouseover="turnblue8()" @mouseleave="turnblue8()" @click="cb()">参股公司</div> -->
                  <div :class="{'dropdown_menu_headline_blue':blue13,'dropdown_menu_headline':!blue13}" @mouseover="turnblue13()" @mouseleave="turnblue13()"  @click="route_join_us()">加入我们</div>
                </div>
            </div>
          </div>
        </div>
      </div>


      <router-view></router-view> 
      
      
      <div class="footer">
            <div class="footer_container">
              <div class="footer_box1">
                <div class="footer_title">
                  产品及方案
                  <p class="footer_line_spe"></p>
                </div>
                <div :class="{'footer_content':opacity1,'footer_content_opacity':!opacity1}" @mouseover="changeopacity1()" @mouseleave="changeopacity1()" @click="route_industrial()">工业设备健康与安全监护</div>
                <!-- <div :class="{'footer_content':opacity2,'footer_content_opacity':!opacity2}" @mouseover="changeopacity2()" @mouseleave="changeopacity2()" @click="router_voice_page1()">超大规模高性能声纹库系统</div>
                <div :class="{'footer_content':opacity3,'footer_content_opacity':!opacity3}" @mouseover="changeopacity3()" @mouseleave="changeopacity3()" @click="router_voice_page2()">高性能计算云平台</div>
                <div :class="{'footer_content':opacity4,'footer_content_opacity':!opacity4}" @mouseover="changeopacity4()" @mouseleave="changeopacity4()" @click="router_voice_page3()">人机耦合平台</div> -->
                <div :class="{'footer_content':opacity5,'footer_content_opacity':!opacity5}" @mouseover="changeopacity5()" @mouseleave="changeopacity5()" @click="router_voice_page4()">智能语音</div>
              </div>
              <div class="footer_box2">
                <div class="footer_title">
                  关于智加
                  <p class="footer_line_spe"></p>
                </div>
                <div :class="{'footer_content':opacity6,'footer_content_opacity':!opacity6}" @mouseover="changeopacity6()" @mouseleave="changeopacity6()" @click="route_introduction()">公司简介</div>
                <div :class="{'footer_content':opacity7,'footer_content_opacity':!opacity7}" @mouseover="changeopacity7()" @mouseleave="changeopacity7()" @click="route_team()">团队介绍</div>
                <div :class="{'footer_content':opacity8,'footer_content_opacity':!opacity8}" @mouseover="changeopacity8()" @mouseleave="changeopacity8()" @click="route_news()">新闻报道</div>
                <div :class="{'footer_content':opacity9,'footer_content_opacity':!opacity9}" @mouseover="changeopacity9()" @mouseleave="changeopacity9()" @click="route_honor()">荣誉资质</div>
                <!-- <div :class="{'footer_content':opacity11,'footer_content_opacity':!opacity11}" @mouseover="changeopacity11()" @mouseleave="changeopacity11()" @click="cb()">参股公司</div> -->
                <div :class="{'footer_content':opacity10,'footer_content_opacity':!opacity10}" @mouseover="changeopacity10()" @mouseleave="changeopacity10()" @click="route_join_us()">加入我们</div>
              </div>
              <div class="footer_box3">
                <div class="footer_title">
                  商务合作
                  <p class="footer_line_spe"></p>
                </div>
                <div class="footer_content2">联系方式：010-62790508</div>
                <div class="footer_content2">商务合作：Market@aithu.com</div>
                <!-- <div class="footer_content2">工作时间：9:00 - 18:00（工作日）</div> -->
                <div class="footer_content2">公司地址：北京市海淀区中关村东路8号原点大厦</div>
                <div class="footer_content_more">AB座七层715单元</div>
              </div>
              <div class="footer_wechat"></div>
            </div>
            <div class="footer_line"></div>
            <div class="footer_beian">
              <div style="display:flex; line-height: 20px">
                <div>Copyright ©2020 北京华控智加科技有限公司</div>
                <div @click="ba()" style="cursor: pointer; margin-left:50px">京ICP备20020587号-1</div>
              </div>
              <div class="footer_beian_line"></div>
              <div style="width:300px; display:flex;">
		 		        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032010" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/static/gongan.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;color:#ffffff;">京公网安备 11010802032010号</p></a>
		 	        </div>
            </div>
      </div>
    </div>
</template>

<script>
  export default {
    data(){
            return{
                isshow: true,
                isshow5: true,
                changecolor1: true,
                changecolor2: true,
                changecolor3: true,
                changecolor4: true,
                headline1: true,
                headline2: true,
                black: false,
                black1: false,
                black2: false,
                black3: false,
                black4: false,
                blue1: true,
                blue2: true,
                blue3: true,
                blue4: true,
                blue5: true,
                blue6: true,
                blue7: true,
                blue8: true,
                blue9: false,
                blue10: false,
                blue11: false,
                blue12: false,
                blue13: false,
                icon1: true,
                icon2: true,
                router: false,
                router1: false,
                router2: false,
                router3: false,
                router4: false,
                us1: false,
                us2: false,
                us3: false,
                us4: false,
                us5: false,
                opacity1: true,
                opacity2: true,
                opacity3: true,
                opacity4: true,
                opacity5: true,
                opacity6: true,
                opacity7: true,
                opacity8: true,
                opacity9: true,
                opacity10: true,
                opacity11: true,
                action1: true,
                action2: true,
                action3: true,
                action4: true,
                action5: true,
            }
        },
        mounted(){
        },
        methods:{
            show(){
              this.isshow=!this.isshow;
              if(this.action3){
                this.black2=!this.black2;
                this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action2 = true;
              this.action1 = true;
              this.action4 = true;
              this.action5 = true;
              }
            },
            show5(){
              this.isshow5=!this.isshow5;
            },
            change1(){
                this.changecolor1=!this.changecolor1;
            },
            change2(){
                this.changecolor2=!this.changecolor2;
            },
            change3(){
                this.changecolor3=!this.changecolor3;
            },
            change4(){
                this.changecolor4=!this.changecolor4;
            },
            turnblackover(){
              
            },
            turnblack(){
              if(this.action1){
                this.black=!this.black;
                this.black1 = false;
              this.black2 = false;
              this.black3 = false;
              this.black4 = false;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = true;
              }
              
            },
            turnblack1(){
              if(this.action2){
                this.black1=!this.black1;
                this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = true;
              }
              
            },
            turnblack2(){
              
              
            },
            turnblack3(){
              if(this.action4){
                this.black3=!this.black3;
                this.black1 = false;
              this.black2 = false;
              this.black = false;
              this.black4 = false;
              this.action2 = true;
              this.action3 = true;
              this.action1 = true;
              this.action5 = true;
              }
              
            },
            turnblack4(){
              if(this.action5){
                this.black4=!this.black4;
                
              this.black1 = false;
              this.black2 = false;
              this.black3 = false;
              this.black = false;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action1 = true;
              }
            },
            turnblue1(){
              this.blue1=!this.blue1;
            },
            turnblue2(){
              this.blue2=!this.blue2;
            },
            turnblue3(){
              this.blue3=!this.blue3;
            },
            turnblue4(){
              this.blue4=!this.blue4;
            },
            turnblue5(){
              this.blue5=!this.blue5;
            },
            turnblue6(){
              this.blue6=!this.blue6;
            },
            turnblue7(){
              this.blue7=!this.blue7;
            },
            turnblue8(){
              this.blue8=!this.blue8;
            },
            turnblue9(){
              if(this.us1==false){
                this.blue9=!this.blue9;
              }
            },
            turnblue10(){
              if(this.us2==false){
                this.blue10=!this.blue10;
              }
            },
            turnblue11(){
              if(this.us3==false){
                this.blue11=!this.blue11;
              }
            },
            turnblue12(){
              if(this.us4==false){
                this.blue12=!this.blue12;
              }
            },
            turnblue13(){
              if(this.us5==false){
                this.blue13=!this.blue13;
              }
            },
            headline1_show(){
              this.$router.push(
                {
                  path:'/product/voice/page1'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            headline2_show(){
              this.$router.push(
                {
                  path:'/technology'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            route_industrial(){
              this.$router.push(
                {
                  path:'/technology'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            router_voice(){
              this.$router.push(
                {
                  path:'/product/voice'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            router_voice_page1(){
              this.$router.push(
                {
                  path:'/product/voice/page1'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            router_voice_page2(){
              this.$router.push(
                {
                  path:'/product/voice/page2'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            router_voice_page3(){
              this.$router.push(
                {
                  path:'/product/voice/page3'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            router_voice_page4(){
              this.$router.push(
                {
                  path:'/product/voice/page1'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action3){
                this.black2 = true;
              }
              this.black1 = false;
              this.black = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = false;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
            },
            route_home(){
              this.$router.push(
                {
                  path:'/'
                }
              );
              if(this.action1){
                this.black = true;
              }
              this.black1 = false;
              this.black2 = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = false;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
              document.documentElement.scrollTop = '0';
            },
            route_technology(){
              this.$router.push(
                {
                  path:'/technology'
                }
              );
              if(this.action2){
                this.black1 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = false;
              this.action3 = true;
              this.action4 = true;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
              document.documentElement.scrollTop = '0';
            },
            
            route_case(){
              this.$router.push(
                {
                  path:'/case'
                }
              );
              if(this.action4){
                this.black3 = true;
              }
              this.black1 = false;
              this.black2 = false;
              this.black = false;
              this.black4 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = false;
              this.action5 = true;
              this.blue9 = false;
              this.blue10 = false;
              this.blue11 = false;
              this.blue12 = false;
              this.blue13 = false;
              document.documentElement.scrollTop = '0';
            },
            route_us(){
              this.$router.push(
                {
                  path:'/us'
                }
              );
              if(this.action5){
                this.black4 = true;
              }
              this.black1 = false;
              this.black2 = false;
              this.black3 = false;
              this.black = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
              document.documentElement.scrollTop = '0';
            },
            route_introduction(){
              this.$router.push(
                {
                  path:'/us/introduction'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action5){
                this.black4 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black1 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
            },
            route_team(){
              this.$router.push(
                {
                  path:'/us/team'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action5){
                this.black4 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black1 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
            },
            route_news(){
              this.$router.push(
                {
                  path:'/us/news'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action5){
                this.black4 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black1 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
            },
            route_honor(){
              this.$router.push(
                {
                  path:'/us/honor'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action5){
                this.black4 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black1 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
            },
            route_join_us(){
              this.$router.push(
                {
                  path:'/us/join_us'
                }
              );
              document.documentElement.scrollTop = '0';
              if(this.action5){
                this.black4 = true;
              }
              this.black = false;
              this.black2 = false;
              this.black3 = false;
              this.black1 = false;
              this.action1 = true;
              this.action2 = true;
              this.action3 = true;
              this.action4 = true;
              this.action5 = false;
            },
            cb(){
              window.open("http://www.zpxy.org/");
            },
            ba(){
              window.open("http://www.beian.miit.gov.cn");
            },
            changeopacity1(){
              this.opacity1=!this.opacity1;
            },
            changeopacity2(){
              this.opacity2=!this.opacity2;
            },
            changeopacity3(){
              this.opacity3=!this.opacity3;
            },
            changeopacity4(){
              this.opacity4=!this.opacity4;
            },
            changeopacity5(){
              this.opacity5=!this.opacity5;
            },
            changeopacity6(){
              this.opacity6=!this.opacity6;
            },
            changeopacity7(){
              this.opacity7=!this.opacity7;
            },
            changeopacity8(){
              this.opacity8=!this.opacity8;
            },
            changeopacity9(){
              this.opacity9=!this.opacity9;
            },
            changeopacity10(){
              this.opacity10=!this.opacity10;
            },
            changeopacity11(){
              this.opacity11=!this.opacity11;
            },
        },
        watch: {
          '$route.path': function(newVal,oldVal){
            if(newVal === '/product/industrial'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/product/speech'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/product/voice/page1'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/product/voice/page2'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/product/voice/page3'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/product/voice/page4'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/us/introduction'){
              this.blue9=true;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=true;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/us/team'){
              this.blue9=false;
              this.blue10=true;
              this.blue11=false;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=true;
              this.us3=false;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/us/news/page1'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=true;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=true;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/us/news/page2'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=true;
              this.blue12=false;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=true;
              this.us4=false;
              this.us5=false;
            }
            else if(newVal === '/us/honor'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=true;
              this.blue13=false;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=true;
              this.us5=false;
            }
            else if(newVal === '/us/join_us'){
              this.blue9=false;
              this.blue10=false;
              this.blue11=false;
              this.blue12=false;
              this.blue13=true;
              this.us1=false;
              this.us2=false;
              this.us3=false;
              this.us4=false;
              this.us5=true;
            }
            else if(newVal == '/technology'){
              this.black1 = true;
            }
          }
        }
  }
</script>

<style scoped>
    .body{
      overflow: hidden;
      font-family:Noto Sans SC;
    }
    .header{
      width:100%;
      height:70px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 11px 0px rgba(164,164,164,0.5);
      position: fixed;
      z-index: 9999999;
      top: 0;
    }
    .header_container{
      width: 1200px;
      height: 100%;
      margin: 0 auto auto auto;
      display: flex;
    }
    .header_logo{
      width: 181px;
      height: 44px;
      background:url('~@/../static/header_logo.png');
      margin-top: 15px;
      cursor: pointer;
    }
    .header_menu{
      width: 649px;
      margin: 24px auto auto 345px;
      display: flex;
      justify-content: space-between;
    }
    .header_menusitems{
      width:64px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(150,150,150,1);
      line-height:22px;
      cursor: pointer;
    }
    .header_menusitems1{
      width:64px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      line-height:22px;
      color:#5C1E7E;
      cursor: pointer;
    }
    .header_menusitems_i{
      width:32px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(150,150,150,1);
      line-height:22px;
      cursor: pointer;
    }
    .header_menusitems_i1{
      width:32px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      line-height:22px;
      color:#5C1E7E;
      cursor: pointer;
    }
    .blue_line_hidden{
      width:0px;
      height:4px;
      background:rgba(36,64,152,1);
      margin: 20px auto auto 0px;
    }
    .blue_line_show{
      width:64px;
      height:4px;
      background:#5C1E7E;
      transition: all 1s;
      margin: 20px auto auto 0px;
    }
    .blue_line_show1{
      width:32px;
      height:4px;
      background:#5C1E7E;
      transition: all 1s;
      margin: 20px auto auto 0px;
    }
    .dropdown_menu_hidden{
      margin: 0px auto auto -68px;
      opacity: 0;
      display: none;
      border: 1px solid #dfdfdf;
    }
    .dropdown_menu_show{
      width:125px;
      background:rgba(255,255,255,1);
      margin: 0px auto auto -30px;
      opacity: 1;
      display: block;
      transition: all 1s;
      position: absolute;
      border: 1px solid #dfdfdf;
    }
    .dropdown_menu_show5{
      width:125px;
      background:rgba(255,255,255,1);
      margin: 0px auto auto -30px;
      opacity: 1;
      display: block;
      transition: all 1s;
      position: absolute;
      border: 1px solid #dfdfdf;
    }
    .dropdown_menu_headline{
      height:60px;
      font-size:16px;
      font-family:Noto Sans SC;
      text-align: center;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:60px;
      white-space: nowrap;
      /* margin-left: 26px; */
      margin-bottom: 0px;
      cursor: pointer;
    }
    .dropdown_menu_headline_blue{
      height:60px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:#5C1E7E;
      line-height:60px;
      white-space: nowrap;
      text-align: center;
      margin-bottom: 0px;
      cursor: pointer;
    }
    .headline1_content_hidden{
      height: 0px;
      display: flex;
      flex-direction: column;
      transition: all 1s;
      justify-content: space-between;
    }
    .headline1_content_show{
      height: 148px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transition: all 1s;
      margin-bottom: 20px;
    }
    .headline2_content_hidden{
      height: 0px;
      transition: all 0.5s;
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
    }
    .headline2_content_show{
      height: 40px;
      transition: all 0.5s;
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
    }
    .dropdown_menu_subtitle1{
      width:208px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(150,150,150,1);
      line-height:22px;
      white-space: nowrap;
      overflow: hidden;
      margin-left: 42px;
      cursor: pointer;
    }
    .dropdown_menu_subtitle1_blue{
      width:208px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(36,64,152,1);
      line-height:22px;
      white-space: nowrap;
      overflow: hidden;
      margin-left: 42px;
      cursor: pointer;
    }
    .dropdown_menu_subtitle2{
      width:208px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(150,150,150,1);
      line-height:22px;
      white-space: nowrap;
      overflow: hidden;
      margin-left: 42px;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .dropdown_menu_subtitle2_blue{
      width:208px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(36,64,152,1);
      line-height:22px;
      white-space: nowrap;
      overflow: hidden;
      margin-left: 42px;
      margin-bottom: 20px;
      cursor: pointer;
    }

    .turn_wider{
      color:rgba(51,51,51,1);
    }
    
  

    .footer{
      width: 100%;
      height: 371px;
      background: url('~@/../static/footer-img.png');
      overflow: hidden;
    }
    .footer_container{
      width: 1200px;
      display: flex;
      margin: 40px auto auto auto;
      padding-bottom: 20px;
    }
    .footer_box1{
      margin-left: 0px;
    }
    .footer_box2{
      margin-left: 290px;
    }
    .footer_box3{
      margin-left: 194px;
    }
    .footer_title{
      width:80px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:22px;
      margin-bottom: 25px;
    }
    .footer_content{
      width: 42px;
      height:20px;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      opacity: 0.6;
      line-height:20px;
      white-space: nowrap;
      margin: 18px auto auto 0;
      cursor: pointer;
    }
    .footer_content2{
      width: 42px;
      height:20px;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      opacity: 0.6;
      line-height:20px;
      white-space: nowrap;
      margin: 18px auto auto 0;
    }
    .footer_content_opacity{
      width: 42px;
      height:20px;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      opacity: 0.9;
      line-height:20px;
      white-space: nowrap;
      margin: 18px auto auto 0;
      cursor: pointer;
    }
    .footer_content_more{
      width: 42px;
      height:20px;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      line-height:20px;
      white-space: nowrap;
      margin: 18px auto auto 70px;
      opacity: 0.6;
    }
    .footer_content_more_opacity{
      width: 42px;
      height:20px;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      line-height:20px;
      white-space: nowrap;
      margin: 18px auto auto 70px;
      cursor: pointer;
      opacity: 0.9;
    }
    .footer_wechat{
      width:134px;
      height:134px;
      background:url('~@/../static/wechat.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      margin: 29px 0px auto auto;
    }
    .footer_line{
      border-bottom: 1px solid rgba(102,102,102,1);
      width: 1920px;
      height: 1px;
      margin: 0 auto auto auto;
    }
    .footer_beian{
      width: 800px;
      margin: 18px auto auto auto;
      font-size:14px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:#ffffff;
      line-height:14px;
      opacity: 0.6;
      display: flex;
    }
    .footer_beian_line{
      border-left: 2px solid #666666;
      width: 1px;
      height: 20px;
      margin: 0 auto auto auto;
    }
    .footer_line_spe{
      width: 31px;
      height: 3px;
      margin-top: 5px;
      background: #5C1E7E;
    }
    .footer_gongan{
      display: flex;
    }
</style>


// WEBPACK FOOTER //
// src/index.vue